<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <p class="font">{{ $t("labels.reported_listing") }}</p>
    </div>
    <div class="ml-auto md:block">
      <vs-button
        color="success"
        icon="icon-search"
        @click="data_hide = !data_hide"
        icon-pack="feather"
        >Search</vs-button
      >
    </div>
    <vx-card class="mt-4" v-show="data_hide">
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/4 w-full">
          <vs-input
            class="w-full"
            icon-pack="feather"
            placeholder="Name"
            icon-no-border
            label="Name"
            v-model="name"
          />
        </div>

        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.user_mode") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_user_mode')"
            name="subcategory_type"
            v-model="mode"
            :success="true"
            success-text="This field is valid"
            :options="modeArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
            :clearable="false"
          />
        </div>
        <div class="vx-col sm:w-1/4 w-full">
          <label class="vs-input--label">{{ $t("labels.category") }}</label>
          <v-select
            v-validate="'required'"
            :placeholder="$t('labels.select_category')"
            name="subcategory_type"
            v-model="category"
            :success="true"
            success-text="This field is valid"
            :options="categoryArray"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            class="w-full"
            label="value"
            :clearable="false"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            color="success"
            class="mr-3 mb-2"
            @click="getAllReportedUsers()"
            >Search</vs-button
          >
          <vs-button color="danger" class="mb-2 mr-3" @click="resetForm()"
            >Reset</vs-button
          >
          <vs-button color="black" class="mb-2" @click="closeForm()"
            >Close</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card class="mt-4">
      <vs-table :max-items="perPage" stripe :data="users">
        <template slot="thead">
          <vs-th>{{ $t("labels.created_by") }}</vs-th>
          <vs-th>{{ $t("labels.reported_By") }}</vs-th>
          <vs-th>{{ $t("labels.type") }}</vs-th>
          <vs-th>{{ $t("labels.date_of_report") }}</vs-th>
          <vs-th>{{ $t("labels.title") }}</vs-th>
          <vs-th>{{ $t("labels.reason") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              class="word-break"
              :data="data[indextr].creator_name"
              style="width: 15% !important"
            >
              {{ data[indextr].creator_name | upper }}
            </vs-td>
            <vs-td
              class="word-break"
              :data="data[indextr].name"
              style="width: 15% !important"
            >
              {{ data[indextr].name | upper }}
            </vs-td>
            <vs-td :data="data[indextr].listing_type">
              {{ data[indextr].listing_type | upper }}
            </vs-td>
            <vs-td :data="data[indextr].created_at">
              {{ data[indextr].created_at | formatDate }}
            </vs-td>
            <vs-td
              :data="data[indextr].listing_type"
              style="word-break: break-all; width: 15%"
            >
              <p v-if="data[indextr].listing_type == 'post'">
                {{ data[indextr].post_data.title }}
              </p>
              <p v-if="data[indextr].listing_type == 'event'">
                {{ data[indextr].event_data.title }}
              </p>
            </vs-td>
            <vs-td
              class="word-break"
              style="width: 25% !important"
              :data="data[indextr].reason"
            >
              {{ data[indextr].reason }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="float-right mt-5">
      <vs-pagination
        ref="paginationApplication"
        :total="totalPage"
        v-model="currentPage"
      ></vs-pagination>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data: () => ({
    value: "",
    select2: "",
    data_hide: false,
    users: [],
    mode: {
      id: "all",
      value: "All",
    },
    category: null,
    name: "",
    changeID: null,
    deleteID: null,
    page: 1,
    perPage: 10,
    totalPage: 0,
    currentPage: 1,
    category_search: "",
    mode_search: "",
    categoryArray: [
      { id: "all", value: "All" },
      { id: "post", value: "Post" },
      { id: "event", value: "Event" },
    ],
    modeArray: [
      { id: "all", value: "All" },
      { id: "created_by", value: "Created By" },
      { id: "reported_by", value: "Reported By" },
    ],
  }),
  watch: {
    currentPage(nv) {
      if (nv) {
        // this.$route.query.page = nv;
        this.getAllReportedUsers();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getAllReportedUsers();
      }
    },
    search(nv) {
      if (!nv) {
        this.perPage = 10;
        this.currentPage = 1;
        if (this.$refs.paginationApplication) {
          this.$refs.paginationApplication.current = 1;
        }
        this.getAllReportedUsers();
      }
    },
  },
  methods: {
    getAllReportedUsers() {
      if (this.category) {
        this.category_search = this.category.id;
      } else {
        this.category_search = "";
      }
      if (this.mode) {
        this.mode_search = this.mode.id;
      } else {
        this.mode_search = "";
      }
      let input = {
        type: this.mode_search,
        category: this.category_search,
        name: this.name,
        page: this.currentPage,
        perPage: this.perPage,
      };
      console.log(input);
      axios
        .post("admin/reportedPosts", input)
        .then((response) => {
          let data = response.data.data;
          this.users = data.reported_posts;
          console.log(this.users);
          if (data.count < this.perPage) {
            this.currentPage = 1;
          }
          this.totalPage = Math.ceil(data.count / this.perPage);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    resetForm() {
      (this.mode = ""),
        (this.category = ""),
        (this.name = ""),
        this.getAllReportedUsers();
    },
    closeForm() {
      this.data_hide = !this.data_hide;
    },
    ClassDetails(id) {
      this.$router.push({ name: "ClassById", params: { id: id } });
    },
  },
  mounted() {
    this.getAllReportedUsers();
  },
};
</script>

<style lang="scss" scoped>
</style>